function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 52,
  height: 52,
  rx: 4,
  stroke: "#C7CAD9",
  strokeWidth: 0.7
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.0714 34.0699C31.0152 37.1263 26.4898 37.7867 22.7864 36.074C22.2397 35.8539 21.7915 35.676 21.3654 35.676C20.1785 35.683 18.7012 36.8339 17.9334 36.067C17.1656 35.2991 18.3173 33.8206 18.3173 32.6266C18.3173 32.2004 18.1464 31.7602 17.9263 31.2124C16.2128 27.5096 16.8741 22.9827 19.9303 19.9272C23.8316 16.0244 30.17 16.0244 34.0714 19.9262C37.9797 23.835 37.9727 30.1681 34.0714 34.0699Z",
  stroke: "#222741",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9393 27.4121H30.9483",
  stroke: "#222741",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9306 27.4121H26.9396",
  stroke: "#222741",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9213 27.4121H22.9303",
  stroke: "#222741",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgChatBkRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBkRec);
export default __webpack_public_path__ + "static/media/Chat_bk_rec.07937531.svg";
export { ForwardRef as ReactComponent };